export default {
  noActiveRecipe: 'Kein aktives Rezept an diesem Ofen.',
};
